import MuiEditIcon from '@mui/icons-material/Edit';

export const EditIcon = (props: any) => <MuiEditIcon {...props} />;
